(function () {
  const SNAP_MS = 220;
  const SWIPE_PX = 10; // telefonda da rahat kayması için küçük tuttuk
  const ease = t => 1 - Math.pow(1 - t, 3);

  // ——— helpers ———
  function fw(t){ return t.clientWidth; }

  // 0..count+1 (0: cloneLast, 1..count: real, count+1: cloneFirst)
  function nearIdx(t){
    const w = fw(t) || 1;
    return Math.round(t.scrollLeft / w);
  }

  function logicalIdx(rawIdx, count){
    if (rawIdx <= 0) return count;
    if (rawIdx >= count + 1) return 1;
    return rawIdx;
  }

  function updateDots(t){
    const dots = t.parentElement.querySelectorAll('.card-media-dots .dot');
    if (!dots.length || !t._count) return;

    const raw = nearIdx(t);   // 0..count+1
    let idx = raw - 1;        // 0..count-1 gerçek index

    if (idx < 0) idx = t._count - 1;
    if (idx >= t._count) idx = 0;

    dots.forEach((d,i)=>d.classList.toggle('is-active', i===idx));
  }

  function animateTo(t, target, onDone){
    t._animating = true;
    const start = t.scrollLeft;
    const delta = target - start;
    const t0 = performance.now();

    function step(now){
      const p = Math.min(1, (now - t0) / SNAP_MS);
      t.scrollLeft = start + delta * ease(p);
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        if (typeof onDone === 'function') onDone();
        t._animating = false;
        updateDots(t);
      }
    }

    requestAnimationFrame(step);
  }

  // ——— buton ile ileri/geri ———
  function goNext(t){
    const w = fw(t);
    const raw = nearIdx(t);               // 0..count+1
    const idx = logicalIdx(raw, t._count); // 1..count

    if (idx === t._count) {
      // son gerçek kare → cloneFirst'e animasyon, sonra 1. kareye snap
      animateTo(t, (t._count + 1) * w, () => {
        t.scrollLeft = 1 * w;
      });
    } else {
      animateTo(t, (idx + 1) * w);
    }
  }

  function goPrev(t){
    const w = fw(t);
    const raw = nearIdx(t);
    const idx = logicalIdx(raw, t._count); // 1..count

    if (idx === 1) {
      // ilk gerçek kare → cloneLast'a animasyon, sonra son kareye snap
      animateTo(t, 0, () => {
        t.scrollLeft = t._count * w;
      });
    } else {
      animateTo(t, (idx - 1) * w);
    }
  }

  // video autoplay (görünürken oynat)
  function setupVideoIO(root){
    const videos = root.querySelectorAll('.card-media-frame video');
    if (!('IntersectionObserver' in window) || !videos.length) return;
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        const v = entry.target;
        if (entry.isIntersecting) {
          v.muted = true;
          const p = v.play();
          if (p && p.catch) p.catch(()=>{});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(v=>io.observe(v));
  }

  const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
  const skipSelectors = '.section--related-products, .section--recently-viewed-products, [class*="featured_collection_RWUfH9"]';

  function initTrack(t) {
    // Zaten initialize edilmiş track'leri atla
    if (t._initialized) return;
    t._initialized = true;

    if (isMobile && t.closest(skipSelectors)) return;

    // 🔒 IMG / VIDEO DRAG KAPAT
    t.querySelectorAll('img, video').forEach(el => {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', e => e.preventDefault());
    });

    // ——— sonsuz döngü için clone ekle ———
    const frames = Array.from(t.children).filter(n=>n.classList?.contains('card-media-frame'));
    const count = frames.length;
    t._count = count;

    if (count > 1 && !t._loopReady) {
      const first = frames[0].cloneNode(true);
      const last  = frames[count - 1].cloneNode(true);

      t.appendChild(first);                  // cloneFirst en sona
      t.insertBefore(last, t.firstChild);    // cloneLast en başa
      t._loopReady = true;

      // klonlarda drag kapat
      t.querySelectorAll('img, video').forEach(el => {
        el.setAttribute('draggable', 'false');
        el.addEventListener('dragstart', e => e.preventDefault());
      });

      // başlangıç: ilk gerçek kare (index 1)
      requestAnimationFrame(()=>{
        t.scrollLeft = fw(t);
        updateDots(t);
      });

      setupVideoIO(t);
    } else {
      setupVideoIO(t);
    }

    // ——— drag-to-swipe + direction lock ———
    let pointerDown = false;
    let dragging = false;
    let moved = false;
    let dragIntent = null;     // null | 'horizontal' | 'vertical'
    let startX = 0;
    let startY = 0;

    // swipe başlangıcı bilgisi
    t._startIdx = 1;         // logic index (1..count)
    t._startScroll = fw(t);  // scrollLeft başlangıcı
    t._startRaw = 1;         // fiziksel index (0..count+1)
    let dxTotal = 0;         // en son dx'imiz

    t.addEventListener('pointerdown', (e)=>{
      // Üst swiper'ların hareketi engellenmesi için
      e.stopPropagation();

      pointerDown = true;
      dragging = false;
      moved = false;
      dragIntent = null;
      startX = e.clientX;
      startY = e.clientY;
      dxTotal = 0;

      if (t.setPointerCapture && e.pointerId != null) {
        t.setPointerCapture(e.pointerId);
      }

      const raw = nearIdx(t);              // 0..count+1
      const idx = logicalIdx(raw, t._count); // 1..count

      t._startIdx = idx;
      t._startRaw = raw;
      t._startScroll = t.scrollLeft;
    }, {passive:false});

    t.addEventListener('pointermove', (e)=>{
      if (!pointerDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      dxTotal = dx;

      // direction lock
      if (!dragIntent) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;

        if (Math.abs(dy) > Math.abs(dx)) {
          dragIntent = 'vertical';
          pointerDown = false;
          if (t.releasePointerCapture && e.pointerId != null) {
            t.releasePointerCapture(e.pointerId);
          }
          return;
        } else {
          dragIntent = 'horizontal';
          dragging = true;
          t.classList.add('is-dragging');
          // Horizontal swipe başladığında üst swiper'ı durdur
          e.stopPropagation();
        }
      }

      if (dragIntent !== 'horizontal') return;

      e.preventDefault();
      e.stopPropagation();
      if (Math.abs(dx) > 1) moved = true;

      const w = fw(t);
      const idx = t._startIdx;
      const base = t._startScroll;

      // 🔑 Parmağı SAĞA çekince (dx>0) → scrollLeft AZALIR → içerik SAĞA gider
      //     Parmağı SOLA çekince (dx<0) → scrollLeft ARTAR → içerik SOLA gider
      let next = base - dx;

      // sadece ±1 slayt aralığında tutalım (start slide ± 1)
      const minScroll = (idx - 1) * w;
      const maxScroll = (idx + 1) * w;
      if (next < minScroll) next = minScroll;
      if (next > maxScroll) next = maxScroll;

      t.scrollLeft = next;
      updateDots(t);
    }, {passive:false});

    function finishSwipe(e){
      if (!pointerDown) return;
      pointerDown = false;

      if (!dragging || dragIntent !== 'horizontal') {
        dragging = false;
        dragIntent = null;
        t.classList.remove('is-dragging');
        return;
      }

      // Horizontal swipe bitti, üst swiper'a gitmesini engelle
      if (e) {
        e.stopPropagation();
      }

      dragging = false;
      dragIntent = null;
      t.classList.remove('is-dragging');

      const w = fw(t);
      const raw = nearIdx(t);              // 0..count+1
      const startRaw = t._startRaw;

      // 1) anlamlı hareket yoksa → başladığın slayta dön
      if (!moved || Math.abs(dxTotal) < SWIPE_PX) {
        // startRaw fiziksel index; clone'da olabilir mi? (bizde pratikte hep gerçek)
        animateTo(t, startRaw * w);
      } else if (raw !== startRaw) {
        // 2) Kullanıcı zaten komşu slayta geçmiş durumda
        //    → sadece o slayta snap et, ekstra ileri/geri gitme
        if (raw === 0) {
          // cloneLast → son gerçek kareye geç
          animateTo(t, 0, () => {
            t.scrollLeft = t._count * w;
            updateDots(t);
          });
        } else if (raw === t._count + 1) {
          // cloneFirst → ilk gerçek kareye geç
          animateTo(t, (t._count + 1) * w, () => {
            t.scrollLeft = 1 * w;
            updateDots(t);
          });
        } else {
          // normal komşu slayt
          animateTo(t, raw * w);
        }
      } else {
        // 3) Komşu slayta tam geçememiş ama ciddi bir çekiş var
        //    → yönüne göre tam 1 item atla (max 1 görsel şartı)
        if (dxTotal > 0) {
          // parmak sağa → önceki slayt
          goPrev(t);
        } else {
          // parmak sola → sonraki slayt
          goNext(t);
        }
      }

      if (moved) {
        const anchor = t.closest('a');
        if (anchor) {
          const cancel = (evt)=>{
            evt.preventDefault();
            anchor.removeEventListener('click', cancel, true);
          };
          anchor.addEventListener('click', cancel, true);
        }
      }
    }

    t.addEventListener('pointerup', finishSwipe);
    t.addEventListener('pointercancel', finishSwipe);
    // pointerleave bazen mobilde garip davranıyor, onu kullanmıyoruz

    // Scroll'da sadece noktaları güncelle
    t.addEventListener('scroll', ()=>{
      if (t._animating) return;
      updateDots(t);
    });

    updateDots(t);

    // dışarıdan ok butonları için istersen:
    t._goNext = () => goNext(t);
    t._goPrev = () => goPrev(t);
  }

  function initAllTracks() {
    document.querySelectorAll('.card-media-track').forEach(initTrack);
  }

  // İlk sayfa yüklemesinde tüm track'leri başlat
  initAllTracks();

  // Filtre uygulandıktan sonra yeni ürün kartları DOM'a eklendiğinde
  // facets.js bu event'i dispatch ediyor — yeni track'leri başlat
  document.addEventListener('collection:rerendered', initAllTracks);
})();

document.addEventListener('DOMContentLoaded', function () {
  // Ürün kartı galerisi içinde herhangi bir şeyi sürüklemeyi tamamen engelle
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.closest('.card-media-scroller')) {
      e.preventDefault();
    }
  });
});
